__turbopack_context__.v({
  "form": "_38N5lq_form",
  "infoBox": "_38N5lq_infoBox",
  "infoContent": "_38N5lq_infoContent",
  "infoIcon": "_38N5lq_infoIcon",
  "infoLink": "_38N5lq_infoLink",
  "infoText": "_38N5lq_infoText",
  "infoTitle": "_38N5lq_infoTitle",
  "panel": "_38N5lq_panel",
  "row": "_38N5lq_row",
});
